module.exports = require('../lib/linkify/plugins/hashtag').default;